import React, { useState,useEffect } from 'react'
import { Button, Input, Select, Table } from "antd";
import "aos/dist/aos.css";
import "../../MainCSS.css";
import { Option } from "antd/es/mentions";
import axios from "axios";
import { toast } from "react-toastify";
import { DeleteAlloyMaster, GetAlloyMaster, SaveAlloyMaster, UpdateAlloyMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi';

const AlloyMaster = () => {

  const userData = sessionStorage.getItem('authToken');
  const userId = sessionStorage.getItem('userId');
  const authHeaders = sessionStorage.getItem('authHeaders');
  const headersObj = JSON.parse(authHeaders).headers;

  
  const userIp = headersObj.userIp
  const deviceSign = headersObj.deviceSign
  const userLong = headersObj.userLong
  const userLat = headersObj.userLat

  const commonHeaders = {
    headers: {
      createdBy: userId,
      updatedBy: userId,
      userIp: userIp,
      userLat: userLat,
      userLong: userLong,
      deviceSign: deviceSign,
    },
  };

const commonHeaders1 = {
  headers: {
    createdBy: userId,
    updatedBy: userId,
  },
}

      const [errors, setErrors] = useState({
        alloyName: "",
        description: "",
      });
     
      const [pageSize, setPageSize] = useState(10);
      const [filteredData, setFilteredData] = useState([]);
      const [currentPage, setCurrentPage] = useState(1);
      const [totalEntries, setTotalEntries] = useState(0);
    
      const [alloyId, setAlloyId] = useState("");
      const [alloyName, setAlloyName] = useState("");
       const [description, setDescription] = useState("");
    
      const [allAlloy, setAllAlloy] = useState([]);
      const [updateButton, setUpdateButton] = useState(false);
      const [saveButton, setSaveButton] = useState(true);
    
    
      //======Search data from table===============
      const handleSearch = (value) => {
        const searchValue = value.toLowerCase();
      
        const filtered = allAlloy.filter((item) =>
          Object.values(item).some((val) =>
            String(val ?? "").toLowerCase().includes(searchValue)
          )
        );
      
        setFilteredData(filtered);
        setTotalEntries(filtered.length);
        setCurrentPage(1);
      };
      //==========Pagination=======================
      const handlePageSizeChange = (value) => {
        setPageSize(value);
      };
    
        // Fetch Alloy Names
        let isAlloyFetched = false;
        useEffect(() => {
          if (isAlloyFetched) return;
          fetchAlloy();
          isAlloyFetched = true;
        }, []);
    
    //=========GET Alloy DATA============
    
      let isError = false;
    
      const fetchAlloy = async () => {
        try {
          const response = await axios.get(GetAlloyMaster,commonHeaders1);
          if (response.data !== null) {
            setAllAlloy(response.data);
            setFilteredData(response.data); 
            setTotalEntries(response.data.length);
          }
        } catch (error) {
          if (!isError) {
            console.error("Error fetching Alloy:", error);
            toast.error("Failed to fetch Alloy data");
            isError = true; 
          }
        }
      };
    
      // const columns = [
      //   {
      //     title: "Sr.No.",
      //     dataIndex: "",
      //     key: "index",
      //     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
      //   },
      //   {
      //     title: "Alloy",
      //     dataIndex: "alloyName",
      //     key: "alloyName",
      //   },       
      //   {
      //     title: "Description",
      //     dataIndex: "description",
      //     key: "description",
      //   },       
      //   {
      //     title: "Actions",
      //     key: "actions",
      //     render: (text, record) => (
      //       <div>
      //         <span
      //           type="submit"
      //           style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
      //           onClick={() => handleEditDataButton(record)}
      //         >
      //           <i class="fa-solid fa-pen-to-square"></i>
      //         </span>
      //         <span
      //           type="submit"
      //           style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
      //           onClick={() => handleDeleteData(record)} 
      //         >
      //           <i class="fa-solid fa-trash"></i>
      //         </span>
      //       </div>
      //     ),
      //   },
      // ];

      const columns = [
  {
    title: "Sr.No.",
    dataIndex: "",
    key: "index",
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Alloy",
    dataIndex: "alloyName",
    key: "alloyName",
    sorter: (a, b) => {
      // Sorting by string value (alphabetical order)
      return String(a.alloyName).localeCompare(String(b.alloyName));
    },
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    sorter: (a, b) => {
      // Sorting by string value (alphabetical order)
      return String(a.description).localeCompare(String(b.description));
    },
  },
  {
    title: "Actions",
    key: "actions",
    render: (text, record) => (
      <div>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
          onClick={() => handleEditDataButton(record)}
        >
          <i class="fa-solid fa-pen-to-square"></i>
        </span>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
          onClick={() => handleDeleteData(record)} 
        >
          <i class="fa-solid fa-trash"></i>
        </span>
      </div>
    ),
  },
      ];
    
      const components = {
        header: {
          cell: ({ children, ...restProps }) => (
            <th
              {...restProps}
              style={{
                backgroundColor: "#023E7D",
                color: "#fff",
                padding: "10px",
                fontSize: "13px",
                borderRadius: "0px",
              }}
            >
              {children}
            </th>
          ),
        },
        body: {
          row: ({ children, ...restProps }) => (
            <tr
              {...restProps}
              style={{
                backgroundColor: "#f0f7fd",
              }}
            >
              {children}
            </tr>
          ),
          cell: ({ children, ...restProps }) => (
            <td
              {...restProps}
              style={{
                padding: "8px",
              }}
            >
              {children}
            </td>
          ),
        },
      };
    
    //=========CANCEL Alloy DATA============
    const handleCancel = () => {
      setAlloyName("");
      setDescription("");
      setUpdateButton(false);
      setSaveButton(true);
      setErrors("");
    };

    //=========SAVE Alloy DATA============
    const handleSubmit = async () => {
        let isValid = true;
        const errorObj = {};
    
        if (!alloyName.trim()) {
          isValid = false;
          errorObj.alloyName = "Alloy Name is required *";
        }
        if (!description.trim()) {
          isValid = false;
          errorObj.description = "Description is required *";
        }
    
        setErrors(errorObj); // Set error messages
    
        if (!isValid) return;
    
        const saveData = {
            alloyName: alloyName,
            description: description,
          };       
        
    
        try {
          const response = await axios.post(SaveAlloyMaster, saveData,commonHeaders);
    
          if (response.data === "CREATED") {
            toast.success("Alloy added successfully!");
            fetchAlloy();
            handleCancel();
          }
          else if (response.data === "ALREADYEXISTED") {
            toast.warn("Alloy already exist!");
          }
        } catch (error) {
          console.error("Error during API call:", error);
          toast.error("Error occurred while submitting data");
        }
    };
    
    //=========EDIT Alloy DATA============
    const handleEditDataButton = (item) => {
      setUpdateButton(true);
      setSaveButton(false);
      window.scrollTo(0, 0);
    
      setAlloyId(item.id);
      setAlloyName(item.alloyName);
      setDescription(item.description);
    };

    //=========UPDATE Alloy DATA============
    const handleUpdate = async () => {
      if ( !alloyName ) {
        toast.warn("Please fill all fields!");
        return;
      }
    
      const updateData = {
        id: alloyId,
        alloyName: alloyName,
        description: description,
      };
    
    
      try {
        const response = await axios.put(UpdateAlloyMaster, updateData,commonHeaders);
    
        if (response.data === "UPDATED") {
          toast.success("Alloy updated successfully!");
          fetchAlloy();
          handleCancel();
        }
        else if (response.data === "ALREADYEXISTED") {
          toast.warn("Alloy already exist!");
        }
      } catch (error) {
        console.error("Error during API call:", error);
        toast.error("Error occurred while updating data");
      }
    };

    //=========DELETE Alloy DATA============
    const handleDeleteData = async (item) => {
      const confirmDelete = window.confirm(
        `Are you sure you want to delete the Alloy "${item.alloyName}"?`
      );
      if (!confirmDelete) return;
    
      try {
        const response = await axios.delete(`${DeleteAlloyMaster}?id=${item.id}`,commonHeaders1);
        if (response.data === "DELETED") {
          toast.success("Alloy deleted successfully!");
          fetchAlloy();
          handleCancel();
        }
      } catch (error) {
        console.error("Error during delete operation:", error);
        toast.error("Error occurred while deleting the Alloy");
      }
    };
    


  return (
     <>
      <div className="px-5 py-3">
          <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
            <div className="col-12">
        
              <div className="row px-md-5 mt-3 p-2">
              
              <div className="col-12 col-md-4"></div>
              <div className="col-12 col-md-4">
                    <div className="row p-0 m-0">

                      <div className="col-12 py-1">
                            <label className="labels">Alloy Name</label>
                            <Input maxLength="250"
                              value={alloyName}
                              onChange={(e) => setAlloyName(e.target.value)}
                              placeholder="Enter Name"
                            />
                            {errors.alloyName && (
                              <div className="errorField">{errors.alloyName}</div>
                            )}
                      </div>
                      <div className="col-12 py-1">
                            <label className="labels">Description</label>
                            <Input.TextArea
                                      value={description}
                                      maxLength="250"
                                      onChange={(e) => setDescription(e.target.value)}
                                      placeholder="Enter Description"
                                      style={{ width: '100%' }}
                                    />
                            {errors.description && (
                              <div className="errorField">{errors.description}</div>
                            )}
                      </div>
        
                    </div>   
              </div>
              <div className="col-12 col-md-4"></div>
                    <div className="col-12 text-center pt-3">
                        <Button
                          type="submit"
                          className="CancelBtn mx-1"
                          onClick={handleCancel}
                        >
                          Cancel
                        </Button>
                        {saveButton && (
                        <Button
                          type="submit"
                          className="SubmitBtn mx-1"
                          onClick={handleSubmit}
                        >
                          Submit
                        </Button>
                        )}
                        {updateButton && (
                          <Button
                            type="submit"
                            className="UpdateBtn mx-1"
                            onClick={handleUpdate}
                          >
                            Update
                          </Button>
                        )}
                    </div>
        
                    <div  className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid rgb(207, 207, 207)" }}></div>
              </div>
        
              {/*================ Table =========================*/}
              <div className="row m-0 p-2 px-md-5 pt-md-0 mt-3">
                <div
                  className="col-12 py-3 shadow border"
                  style={{ backgroundColor: "white" }}
                >
                  <div
                    className="col-12 px-md-5"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div>
                      <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                      <Select
                        defaultValue={pageSize}
                        onChange={handlePageSizeChange}
                        style={{ width: 120, textAlign: "center" }}
                      >
                        <Option value={10}>10</Option>
                        <Option value={20}>20</Option>
                        <Option value={30}>30</Option>
                      </Select>
                    </div>
        
                    <div className="pt-4 pt-md-0">
                      <Input.Search
                        placeholder="Search"
                        onChange={(e) => handleSearch(e.target.value)}
                        style={{ width: 200, marginBottom: 16 }}
                      />
                    </div>
                  </div>
        
                  <div style={{ backgroundColor: "white" }}>
                    <Table
                      bordered
                      style={{ padding: "0px 20px", overflowX: "auto" }}
                      columns={columns}
                      dataSource={filteredData}
                      pagination={{
                        pageSize: pageSize,
                        total: totalEntries,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        current: currentPage,
                        onChange: (page) => setCurrentPage(page),
                      }}
                      showSorterTooltip={false}
                      rowKey={(record) => record.id}
                      components={components}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>

       </>
  )
}

export default AlloyMaster